module.exports = __webpack_public_path__ + "img/789.52085e9f.png";